import script from './script';

export default function Messenger() {
  return (
    <>
      <div id='fb-root'> </div>{' '}
      <script
        dangerouslySetInnerHTML={{
          __html: myFunction(),
        }}
      />
      <div
        className='fb-customerchat'
        attribution='setup_tool'
        page_id='943012355788480'
        theme_color='#1A5CB8'
      ></div>{' '}
    </>
  );
}

function myFunction() {
  window.fbAsyncInit = function () {
    window.FB.init({
      xfbml: true,
      version: 'v9.0',
    });
  };

  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
}
